var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaperplane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 51,
    viewBox: "0 0 66 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.528872 14.9439L64.8502 0.0249069C65.4246 -0.104883 65.8828 0.489419 65.6092 1.00858L39.3227 50.6362C39.097 51.0597 38.5158 51.128 38.2012 50.766L23.5193 33.9548L17.3648 41.1889C17.0092 41.6055 16.3322 41.4553 16.1818 40.9293L11.8873 25.6004L0.255339 16.1394C-0.189152 15.7842 -0.0250319 15.0737 0.528872 14.9439Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M11.894 25.601L64.85 0.0255684C65.2603 -0.117884 65.9373 0.36029 65.6091 1.00924L23.5192 33.9554L17.3647 41.1895C17.0091 41.6062 16.3321 41.4559 16.1817 40.9299L11.894 25.601Z",
    fill: "#FBFBFB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 45.7368,
    y1: 13.5,
    x2: -52.7632,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30FFB4"
  })))));
}

export default SvgPaperplane;